export default class FileDownloadUtil {
    public static readBlobAsArrayBuffer = (blob: Blob): Promise<ArrayBuffer> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.result instanceof ArrayBuffer) {
                    resolve(reader.result);
                } else {
                    reject(new Error('Failed to read blob as ArrayBuffer'));
                }
            };
            reader.onerror = reject;
            reader.readAsArrayBuffer(blob);
        });
    };
}


// WEBPACK FOOTER //
// ./src/util/FileDownloadUtil.ts